var vs = document.querySelectorAll(".variant-select");
for (let i = 0; i < vs.length; i++) {
  const select = vs[i];
  var avaliable = select.querySelectorAll(".link_anchor.available");
  for (let i = 0; i < avaliable.length; i++) {
    avaliable[0].classList.add("active");
  }
}

function quickATC(e) {
  var pcard = e.parentElement;
  var variants = pcard.querySelector(".variant-select");
  console.log(pcard);
  var allCards = document.querySelectorAll(".product-grid-item");
  for (let i = 0; i < allCards.length; i++) {
    const element = allCards[i];
    element.querySelector(".variant-select").classList.remove("active");
  }
  variants.classList.add("active");
}

/* Card Variant Change */
function cardVariant(e, parent, val) {
  var cardForm = parent;
  var cardId = cardForm.querySelector(".card__form select");
  var variantSibs = e.parentNode.querySelectorAll("*");
  for (var i = 0; i < variantSibs.length; i++) {
    variantSibs[i].classList.remove("active");
  }
  e.classList.add("active");
  cardForm.classList.add("active");
  cardId.value = val;
}

function closThis(e) {
  e.parentElement.classList.remove("active");
}

// gift wrapping

const giftWrapCheckbox = document.querySelectorAll(".gift-wrap-checkbox");
for (let i = 0; i < giftWrapCheckbox.length; i++) {
  giftWrapCheckbox[i].addEventListener("change", function () {
    const isChecked = this.checked;

    // Send an AJAX request to update the cart
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          gift_wrap: isChecked ? "Yes" : "No",
        },
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        console.log("Gift wrap updated:", cart);
      })
      .catch((error) => console.error("Error updating gift wrap:", error));
  });
}
document.querySelector(".gift-wrap-checkbox");

document.addEventListener("DOMContentLoaded", function () {
  // Fetch the current cart state
  fetch("/cart.js", {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => response.json())
    .then((cart) => {
      // Check if the gift_wrap attribute is set
      const giftWrapSelected =
        cart.attributes && cart.attributes.gift_wrap === "Yes";

      // Set the checkbox state
      const giftWrapCheckbox = document.querySelector(".gift-wrap-checkbox");
      if (giftWrapCheckbox) {
        giftWrapCheckbox.checked = giftWrapSelected;
      }
    })
    .catch((error) => console.error("Error fetching cart data:", error));
});

const cartToggle = document.querySelectorAll(".cart-toggle");
for (let i = 0; i < cartToggle.length; i++) {
  cartToggle[i].addEventListener("click", function () {
    const body = document.querySelector("body");
    if (body) {
      body.classList.toggle("cart-open");
    }
  });
}
